import { combineReducers } from "@reduxjs/toolkit";
import AuthRed from "../reducers/agents/auth/authReducer";
export const reducers = combineReducers({
  AuthRed,
});
